import moment from "moment";
import dateFormats from "./dateFormats";

export default (date? : string | null, emptyPlaceholder : string = "-") : string => {
	if (!date) {
		return emptyPlaceholder;
	}
	return moment(date).format(dateFormats.date);
}
